import {Outlet} from 'react-router-dom'
import {Version} from 'components/generic/Version'
import packageJSON from '../../package.json'
import AppHeader from 'components/new/Header'
import AppFooter from 'components/new/Footer'
import NewPortalBanner from 'components/new/NewPortalBanner'
import {Toaster} from 'react-hot-toast'

let {version} = packageJSON

export const Layout = () => {
  return (
    <>
      <NewPortalBanner />
      <AppHeader />
      <>
        <Outlet />
      </>
      <AppFooter />
      <Toaster
        position="bottom-right"
        toastOptions={{duration: 3000}}
        reverseOrder={false}
      />
      <Version version={version} />
    </>
  )
}
